var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lleno-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjcyNjYgMy41OTMzQzMwLjA5MTEgMy4yMjg4MSAzMC4wOTExIDIuNjM3ODYgMjkuNzI2NiAyLjI3MzM3QzI5LjM2MjEgMS45MDg4OCAyOC43NzEyIDEuOTA4ODggMjguNDA2NyAyLjI3MzM3TDE2IDE0LjY4MDFMMy41OTMzIDIuMjczMzdDMy4yMjg4MSAxLjkwODg4IDIuNjM3ODYgMS45MDg4OCAyLjI3MzM3IDIuMjczMzdDMS45MDg4OCAyLjYzNzg2IDEuOTA4ODggMy4yMjg4MSAyLjI3MzM3IDMuNTkzM0wxNC42ODAxIDE2TDIuMjczMzcgMjguNDA2N0MxLjkwODg4IDI4Ljc3MTIgMS45MDg4OCAyOS4zNjIxIDIuMjczMzcgMjkuNzI2NkMyLjYzNzg2IDMwLjA5MTEgMy4yMjg4MSAzMC4wOTExIDMuNTkzMyAyOS43MjY2TDE2IDE3LjMxOTlMMjguNDA2NyAyOS43MjY2QzI4Ljc3MTIgMzAuMDkxMSAyOS4zNjIxIDMwLjA5MTEgMjkuNzI2NiAyOS43MjY2QzMwLjA5MTEgMjkuMzYyMSAzMC4wOTExIDI4Ljc3MTIgMjkuNzI2NiAyOC40MDY3TDE3LjMxOTkgMTZMMjkuNzI2NiAzLjU5MzNaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .s0 { fill: #ed0039 } \n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m40 80c-22.1 0-40-17.9-40-40 0-22.1 17.9-40 40-40 22.1 0 40 17.9 40 40 0 22.1-17.9 40-40 40z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Union",
    href: "#img1",
    transform: "matrix(1,0,0,1,24,24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/iconError.7f22621659d111bfa3ad3b68b248db84.svg";
export { ForwardRef as ReactComponent };